export default __webpack_public_path__ + "2c4b95c673df163f8bcca7b8921069d3.jpg";